module.exports = __webpack_public_path__ + "img/agency-black.73c57701.svg";